import { safeDefine } from "../../registration/safe-define.js";
import { MenuSeparatorElement } from "../../ui/menu/separator.js";
//#region src/define/ui/menu-separator.ts
safeDefine(MenuSeparatorElement);
//#endregion
